import { MetadataField, MISSING_REPORTED_AS_LABEL } from '../../../../../../constnats/reportConstants';
import type { ReportType } from '../../../../../../schemas/report.schemas';
import type { DescriptorType } from '../../../../../../types/descriptor.types';

export function findPlaceholderReportedAsLabels(reports: readonly ReportType[], descriptors: readonly DescriptorType[]) {
    const labelsById = new Map<string, string>();
    const collectLabels = (fields: readonly DescriptorType[]) => {
        for (const field of fields) {
            labelsById.set(field.id, field.label);
            collectLabels(field.subFields ?? []);
        }
    };
    collectLabels(descriptors);

    return reports.map(report => {
        const fields = Object.entries(report.metadata?.fieldSpecific ?? {}).flatMap(([descriptorId, metadata]) => {
            const reportedAsLabel = metadata?.[MetadataField.REPORTED_AS_LABEL];
            if (reportedAsLabel !== MISSING_REPORTED_AS_LABEL) {
                return [];
            }
            return [{ descriptorId, label: labelsById.get(descriptorId) || descriptorId, reportedAsLabel }];
        }).sort((a, b) => a.descriptorId.localeCompare(b.descriptorId));

        return {
            reportId: report.id,
            year: report.year,
            period: report.period,
            type: report.type,
            reportType: report.reportType,
            fields,
        };
    }).filter(report => report.fields.length > 0)
        .sort((a, b) => a.reportId - b.reportId);
}
